/** @format */

import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import Loading from '../../Shared/Components/Loading';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { checkLogin } from '../../Shared/hooks/authenticate';
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({
  event_id: Yup.number()
    .typeError('انتخاب رویداد الزامی است')
    .required('انتخاب رویداد الزامی است'),
  issue_tracking: Yup.string()
    .typeError('وارد کردن کد پیگیری ضروری است')
    .required('وارد کردن کد پیگیری ضروری است'),
});

const PaymentTracking = () => {
  const eventContext = useContext(EventContext);
  const { categories, events } = eventContext;
  const [loading, setLoading] = useState(false);
  const [loadingEvents, setLoadingEvent] = useState(false);
  const [loadSubmitForm, setLoadSubmitForm] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!checkLogin()) {
      error('برای ادامه ابتدا وارد حساب کاربری خود شوید');
      navigate('/login', { replace: true });
      return;
    }
  }, []);

  useEffect(() => {
    const getCategories = async () => {
      setLoading(true);
      await useApi.get(
        '/category?no-paginate=true',
        {},
        (res) => {
          let data = res.data.data;

          eventContext.categories = data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
    };

    getCategories();
  }, []);

  const selectCategory = async (slug) => {
    setLoadingEvent(true);
    await useApi.get(
      `/category/${slug}/event`,
      {},
      (res) => {
        let data = res.data.data;
        eventContext.events = data;
        setLoadingEvent(false);
      },
      (err) => {
        setLoadingEvent(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const onSubmitForm = async (values, setSubmitting) => {
    setSubmitting(true);
    setLoadSubmitForm(true);
    await useApi.get(
      `/tracking/event/${values.event_id}?issue_tracking=${values.issue_tracking}`,
      {},
      async (res) => {
        let data = res.data.data;
        if (data?.success !== undefined && data?.success == false) {
          setSubmitting(false);
          setLoadSubmitForm(false);
          return error(data?.message);
        }
        let request = {};
        if (data?.event?.type == 1) {
          request['user_id'] = data.id;
        } else {
          request['team_id'] = data.id;
        }
        request['event_id'] = values.event_id;
        await useApi.post(
          '/payment',
          request,
          (res) => {
            let data2 = res.data.data;
            if (data2?.success == false) {
              return error(data2?.message);
            }

            return (window.location.href = data2?.redirect_url);
          },
          (err) => {
            error('خطای ناشناخته ای پیش آمده است');
            console.log(err);
          },
        );
        setSubmitting(false);
        setLoadSubmitForm(false);
      },
      (err) => {
        setSubmitting(false);
        setLoadSubmitForm(false);
        error('خطایی هنگام ارسال اطلاعات رخ داده است');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master
      showSidebar={false}
      containerFullWidth={true}
      headerFixed={true}
      title='پرداخت هزینه رویداد از طریق کد پیگیری'
    >
      <Formik
        initialValues={{
          event_id: '',
          issue_tracking: '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='w-100 bg-dark-mode-3 d-flex flex-column vh-100 p-2'>
              <div className='row mx-2 overflow-hidden'>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <label className='text-dark-mode f-12 font-weight-bold'>
                      دسته بندی
                    </label>

                    <select
                      className='form-control'
                      onChange={(e) => selectCategory(e.target.value)}
                    >
                      <option value='انتخاب کنید'>انتخاب کنید</option>
                      {categories.length > 0 &&
                        categories?.map((item) => (
                          <option value={item?.slug}>{item?.title}</option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <label className='text-dark-mode f-12 font-weight-bold'>
                      رویداد
                    </label>

                    <select
                      className='form-control'
                      name='event_id'
                      onChange={handleChange}
                      value={values.event_id}
                    >
                      <option value='انتخاب کنید'>انتخاب کنید</option>

                      {events.length > 0 &&
                        events.map((item) => (
                          <option value={item?.id}>{item?.title}</option>
                        ))}
                    </select>
                    <ErrorMessage error={errors.event_id} classes='my-2' />
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <label className='text-dark-mode f-12 font-weight-bold'>
                      کد پیگیری
                    </label>
                    <input
                      name='issue_tracking'
                      value={values.issue_tracking}
                      onChange={handleChange}
                      className='form-control'
                      type='text'
                    />
                    <ErrorMessage
                      error={errors.issue_tracking}
                      classes='my-2'
                    />
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group d-flex flex-row justify-content-end mt-4'>
                    <button className='btn btn-danger f-14 btn-sm' type='text'>
                      {loadSubmitForm ? (
                        <div
                          className='spinner-border spinner-border-sm text-white mb-1'
                          role='status'
                        ></div>
                      ) : (
                        'پرداخت'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default PaymentTracking;
